import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import sv from "./locales/sv.json";

const resources = {
  en: { translation: en },
  sv: { translation: sv },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "sv",
  fallbackLng: "sv",
  interpolation: {
    escapeValue: false,
  },
  initImmediate: false,
});

export default i18n;
